import { matchesCustomViewport, resolveNamedViewport } from './wing/base-wing-view-model';
import type { FieldMetaDataInterface, ResponsiveConfigurationInterface, ResponsiveConfigurationViewportInterface } from '@nts/std/interfaces';

function resolveNamedResponsiveConfiguration(
  viewportWidth: number,
  responsiveConfiguration?: ResponsiveConfigurationInterface
): ResponsiveConfigurationViewportInterface | null {
  const viewportKey = resolveNamedViewport(viewportWidth);
  return responsiveConfiguration?.named?.[viewportKey] ?? null;
}

export function resolveResponsiveConfiguration(
  viewportWidth: number,
  responsiveConfiguration?: ResponsiveConfigurationInterface
): ResponsiveConfigurationViewportInterface | null {
  const matchedCustomRule = responsiveConfiguration?.custom?.find((rule) => matchesCustomViewport(viewportWidth, rule));

  if (matchedCustomRule != null) {
    return matchedCustomRule;
  }

  return resolveNamedResponsiveConfiguration(viewportWidth, responsiveConfiguration);
}

export function resolveResponsiveFieldMetaData<TField extends FieldMetaDataInterface>(
  viewportWidth: number,
  field: TField
): TField {
  const responsiveConfiguration = resolveResponsiveConfiguration(
    viewportWidth,
    (field as TField & { responsiveConfiguration?: ResponsiveConfigurationInterface; }).responsiveConfiguration
  );

  if (responsiveConfiguration == null) {
    return field;
  }

  return {
    ...field,
    isVisible: responsiveConfiguration.isVisible ?? field.isVisible,
    isAdditionalField: responsiveConfiguration.isAdditionalField ?? field.isAdditionalField,
    isFullColumn: responsiveConfiguration.isFullColumn ?? field.isFullColumn,
    position: responsiveConfiguration.position ?? field.position,
  };
}
